<template>
  <div>
    <el-table v-loading="loading" :data="userOrderList" @sort-change="handleSortChange">
      <el-table-column align="center" label="预约医生" prop="channelName" :show-overflow-tooltip="true" width="180"/>
      <el-table-column align="center" label="备注" prop="adminRemark" />
      <el-table-column align="center" label="预约时间" prop="appointDate" width="180" :show-overflow-tooltip="true" sortable="custom"  :sort-orders="['descending', 'ascending']">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.appointDate, '{y}-{m}-{d}') }} {{scope.row.timeSegmentName}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="渠道价格" prop="channelPrice" />

      <el-table-column align="center" label="状态" prop="status">
        <template slot-scope="scope">
          {{ getSelectNameByEnumsAndValue(statusList, scope.row.status) }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="创建时间" prop="payDate" width="120" sortable="custom"  :sort-orders="['descending', 'ascending']">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.createDate, '{y}-{m}-{d} {h}:{i}') }}</span>
        </template>
      </el-table-column>
    </el-table>
    <pagination
        v-show="total>0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"
    />
  </div>
</template>

<script>


import {listChannelUser} from "@/api/biz/ChannelUser";
import {getEnumByClassFullName} from "@/api/biz/common";

export default {
  props: {
    user: {
      type: Object
    }
  },
  data() {
    return {
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
      },
      loading: true,
      // 总条数
      total: 0,
      statusList:[],
      // 用户体重记录表格数据
      userOrderList: [],
    };
  },
  created() {
    this.getChannelOrderStatusEnum();
    this.getList();
  },
  methods: {
    /** 排序触发事件 */
    handleSortChange(column, prop, order) {
      this.queryParams.orderByColumn = column.prop;
      this.queryParams.isAsc = column.order;
      this.getList();
    },
    getChannelOrderStatusEnum() {
      getEnumByClassFullName("com.myzs.project.biz.enums.ChannelOrderStatusEnum").then(res => {
        this.statusList = res.data;
      })
    },
    /** 查询用户体重记录列表 */
    getList() {
      this.queryParams.userId = this.user.id;
      this.loading = true;
      listChannelUser(this.queryParams).then(response => {
        this.userOrderList = response.rows;
        this.total = response.total;
        this.loading = false;
      });
    },
    close() {
      this.$tab.closePage();
    }
  }
};
</script>
